import { Box, Flex, Text } from '_shared/designSystem/components';
import PropTypes from 'prop-types';

export default function Badge(props) {
  const { text, colour, withleftCircle, rounded, px, py, fontSize, ...rest } = props;
  return (
    <Flex bg={`${colour}.50`} px={px} py={py} display="inline-block" borderRadius={rounded ? '16px' : null} {...rest}>
      <Flex gap={2} alignItems="center">
        {withleftCircle && (
          <Flex alignItems="center" justifyContent="center">
            <Box w="6px" h="6px" borderRadius={'6px'} bg={`${colour}.500`} />
          </Flex>
        )}
        <Text fontSize={fontSize} fontWeight="medium" color={`${colour}.700`}>
          {text}
        </Text>
      </Flex>
    </Flex>
  );
}

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  colour: PropTypes.string,
  rounded: PropTypes.bool,
  px: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  py: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array])
};

Badge.defaultProps = {
  colour: 'primary',
  rounded: true,
  withleftCircle: false,
  px: 2,
  fontSize: 'xs'
};
